<script setup lang="ts" generic="T extends Record<string, any> | undefined = undefined">
import type { Emits, Props } from './types';
import TopButton from '@/components/forms/button/button.vue';
import TopPopup from '@/components/popup/popup/popup.vue';

const props = defineProps<Props<T>>();

defineEmits<Emits<T>>();

// сужение объекта для propsPopup
const {
	submitText,
	...propsPopup
}: Props<T> = props;
</script>

<template>
	<!-- @vue-generic {T} -->
	<TopPopup
		class="top-popupAlert"
		:=propsPopup
		@open="$emit('open', $event)"
		@close="$emit('close', $event)"
		@scrollContentList="(...args) => $emit('scrollContentList', ...args)"
	>
		<template #opener>
			<!-- @slot Элемент для открытия Popup -->
			<slot name="opener"></slot>
		</template>

		<template #header v-if="$slots.header">
			<!-- @slot Шапка -->
			<slot name="header"></slot>
		</template>

		<template #content v-if="$slots.default">
			<!-- @slot Контент в свободной форме -->
			<slot></slot>
		</template>

		<template #footer>
			<!-- @slot Футер -->
			<slot name="footer"></slot>

			<TopButton>
				{{ submitText || $i18n.Common.Close }}
			</TopButton>
		</template>
	</TopPopup>
</template>
